import { PdfConfigInput } from 'sr-types/lib/reporting/v1/graphql';
import { useMutationWithContext } from '../../hooks/useMutationWithContext';
import { client, generateReportQuery } from './report';

export const useGenerateReport = () => {
    const [save] = useMutationWithContext(generateReportQuery, client);

    const generateReport = (
        reportTitle: string,
        content: string,
        pageConfig: PdfConfigInput,
        contextTerm?: string,
        tags?: string,
        fileName?: string,
        restricted?: boolean
    ) => {
        return save({
            variables: {
                reportTitle,
                content,
                pageConfig,
                contextTerm,
                tags,
                fileName,
                restricted
            }
        })
            .then((generateReportResponse) => {
                if (generateReportResponse.data?.errors) return Promise.reject(generateReportResponse);
                return generateReportResponse;
            })
            .catch((err) => Promise.reject(err));
    };

    return { generateReport };
};
